import { render } from "./ClassPage.vue?vue&type=template&id=6dd447ec"
import script from "./ClassPage.vue?vue&type=script&lang=js"
export * from "./ClassPage.vue?vue&type=script&lang=js"

import "./ClassPage.vue?vue&type=style&index=0&id=6dd447ec&lang=css"

import exportComponent from "/Users/kaho/cloudfit-pro-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__